// extracted by mini-css-extract-plugin
module.exports = {"layout":"HostedPage_layout__NbP_f"};